export enum LocaleNS {
    COMMON = 'common',
    LANDING = 'landing',
    AUTH = 'auth',
    EDITOR = 'editor',
    CATALOG = 'catalog',
    CHECKOUT = 'checkout',
    NAV_BARS = 'nav-bars',
    BOTTOM_BAR = 'bottom-bar',
    TUTORIALS = 'tutorials',
    CONTACT = 'contact',
    ABOUT = 'about',
    PRINT = 'print'
}
